export default "__VITE_ASSET__65caf15c__"